import { useEffect, useRef, useState } from "react";
import { FormControl } from "react-bootstrap";
import { BsSearch } from "react-icons/bs";
import { PALETTE } from "../ThemeConstants";

export default // Custom Select component with search functionality
    function CustomSelectWithSearch({ options, value, onChange, onFilter, filterText, width }) {
    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);

    const selectedOption = options.find(option => option.id == value) || { name: "Select an exercise" };

    const filteredOptions = options.filter(option =>
        option.name.toLowerCase().includes(filterText.toLowerCase())
    );

    const handleSelect = (optionId) => {
        onChange({ target: { value: optionId } });
        setShow(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="custom-select-container" ref={dropdownRef}>
            <div
                className="form-select d-flex justify-content-between align-items-center"
                onClick={() => setShow(!show)}
                style={{ cursor: "pointer" }}
            >
                <div>{selectedOption.name}</div>
            </div>

            {show && (
                <div
                    className="position-absolute bg-white border rounded mt-1"
                    style={{
                        zIndex: 1000,
                        maxHeight: "250px",
                        overflowY: "auto",
                        width: width || "fit-content",
                    }}>
                    <div className="p-2">
                        <div className="input-group">
                            <span className="input-group-text" style={{ border: "none", background: PALETTE.LIGHTGRAY }}>
                                <BsSearch />
                            </span>
                            <FormControl
                                placeholder="Search by name..."
                                style={{ border: "none", background: PALETTE.LIGHTGRAY }}
                                value={filterText}
                                onChange={(e) => onFilter(e)}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                    </div>

                    <div>
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map(option => (
                                <div
                                    key={option.id}
                                    className={`p-2 ${option.id == value ? 'bg-light' : ''}`}
                                    onClick={() => handleSelect(option.id)}
                                    style={{ cursor: "pointer" }}
                                >
                                    {option.name}
                                </div>
                            ))
                        ) : (
                            <div className="p-2 text-muted">No exercises found</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
